import PropTypes from 'prop-types';
import React from 'react';
import ExternalIcon from './ExternalIcon/ExternalIcon';
import { StyledLinkTarget, StyledPlayLinkExternal } from './PlayLinkExternal.styles';

class PlayLinkExternal extends React.Component {
    render() {
        let { url, text, ...other } = this.props;

        if (!text) {
            text = this.props.children;
        }

        return (
            <StyledPlayLinkExternal to={url} isExternal={true} {...other}>
                <ExternalIcon isExternal={true}>
                    <StyledLinkTarget>{text}</StyledLinkTarget>
                </ExternalIcon>
            </StyledPlayLinkExternal>
        );
    }
}

PlayLinkExternal.propTypes = {
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
    className: PropTypes.string,
};

export default PlayLinkExternal;
